<i18n>
{
  "en": {
    "welcome": "Welcome, {0}"
  },
  "es": {
    "welcome": "Bienvenido, {0}"
  }
}
</i18n>
<template>
  <div class="d-flex flex-column align-center mt-3">
    <div class="text-center font-weight-bold ma-1 text-md-h6 text-body-1">{{welcomeMessage}}</div>
    <completion-widget @click="onCompletionByPos"/>
  </div>
</template>

<script>
import { Components, MapActions, MapGetters } from '@core/helpers/decorators';
import Component from 'vue-class-component';
import Vue from 'vue';
import CompletionWidget from './components/CompletionWidget.vue';

@Component
@Components({ CompletionWidget })
@MapActions(['setSelectedPointOfSaleGuid'])
@MapGetters(['user'])
export default class ProfileDashboard extends Vue {
  async onCompletionByPos() {
    await this.$router.push({ name: 'completion', params: { pointOfSaleGuid: null } });
  }

  get welcomeMessage() {
    return this.$t('welcome', [this.user]);
  }
}
</script>
